
import { Collapse } from 'bootstrap';
import Swiper from 'swiper/bundle';



const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight);

// 初期化
setFillHeight();

const navbarSmallMenu = document.getElementById('navbar-sm-menu');
const navbarSmallSearch = document.getElementById('navbar-sm-search');

navbarSmallMenu.addEventListener('show.bs.collapse', (e) => {
  // e.getInstance();
});

navbarSmallSearch.addEventListener('show.bs.collapse', (e) => {
  // console.log( e );
  // navbarSmallMenu.hide();
});

const swiperMainVisual = document.getElementById('swiper-main-visual');
if( swiperMainVisual ){

  const swiper = new Swiper('#swiper-main-visual', {
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    spaceBetween: 0,
    loop: true,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    }
  });
  
}
